import axios from 'axios'

const axiosApi = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL !== undefined ? process.env.VUE_APP_BASE_URL : '//trackerapp.local/'
})

export const setAuthHeader = (token) => {
  axiosApi.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

setAuthHeader(localStorage.getItem('authtoken'))

export default axiosApi



// WEBPACK FOOTER //
// ./src/axios/axiosAPI.js